import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';

import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  arrayMove,
} from 'react-sortable-hoc';

import { getPostIndexRef, getPostRef } from '../../../../config/firebase';
import { getAllItems, updateLastUpdatedTimestamp } from '../../../../utils';

import Loader from '../../../../components/Loader';
import CSSListItemTransition from '../CSSListItemTransition'

const DragHandle = SortableHandle(() => (<span className="sortable-handle">&#8942;&#8942;</span>));

const postTypeIcons = {
  'text': 'description',
  'audio': 'music_note',
  'video': 'local_movies',
}

const SortableItem = SortableElement(({post, postList}) => {
  let subtitle = post.content
    ? post.content
    : '';

  subtitle = subtitle.length > 70
    ? subtitle.substring(0,70) + '...'
    : subtitle;

  return (
    <ListItem divider>
      <DragHandle />
      <Avatar>
        <Icon>{postTypeIcons[post.type]}</Icon>
      </Avatar>
      <ListItemText primary={post.title} secondary={subtitle} />
      <ListItemSecondaryAction>
        <IconButton
          component={Link}
          to={`/${postList.props.screen}/${post.id}/${postList.props.visibility}`}
          color="primary"
        >
          <Icon>edit</Icon>
        </IconButton>
        <IconButton
          aria-label="delete"
          color="secondary"
          onClick={() => postList.conformPostDeletion(post)}
        >
          <Icon>delete</Icon>
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
});

const SortableList = SortableContainer(({posts, postList}) => {
  return (
    <List>
      <CSSListItemTransition>
        {posts.map((post, index) => (
          <SortableItem key={`item-${index}`} index={index} post={post} postList={postList} />
        ))}
      </CSSListItemTransition>
    </List>
  );
});

class PostsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      posts: null,
      postToDelete: {},
      isDialogOpen: false,
    }

    this.postsRef = getPostIndexRef(props.visibility);

    this.conformPostDeletion = this.conformPostDeletion.bind(this)
    this.handleDialogClose   = this.handleDialogClose.bind(this)
    this.handlePostDeletion  = this.handlePostDeletion.bind(this)
    this.onSortEnd           = this.onSortEnd.bind(this)
  }

  componentDidMount() {
    getAllItems(this.postsRef, (posts) => {
      posts = posts.filter(post => post.screen === this.props.screen);

      if (posts.length > 0) {
        this.setState({ posts });
      } else {
        this.setState({ posts: 'no-posts' });
      }
    });
  }

  componentWillUnmount() {
    this.postsRef.off();
  }

  conformPostDeletion(post) {
    this.setState({
      postToDelete: post,
      isDialogOpen: true,
    });
  }

  handlePostDeletion() {
    getPostRef(this.state.postToDelete.id, this.props.visibility).remove().then(() => {
      updateLastUpdatedTimestamp();
      this.setState({
        postToDelete: {},
        isDialogOpen: false
      });
    });
  }

  handleDialogClose() {
    this.setState({
      isDialogOpen: false,
    });
  }

  onSortEnd = ({oldIndex, newIndex}) => {
    let {posts} = this.state;
    posts = arrayMove(posts, oldIndex, newIndex);

    posts.forEach((post, index) => {
      getPostRef(post.id, this.props.visibility).child('order').set(index)
    });

    updateLastUpdatedTimestamp();
    this.setState({posts});
  };

  render() {
    if ( !this.state.posts ) {
      return (
        <Loader />
      )
    }

    let list;

    if ( this.state.posts === 'no-posts' ) {
      list = <p><br/> No posts to show!</p>
    } else {
      list = <SortableList posts={this.state.posts} onSortEnd={this.onSortEnd} useDragHandle={true} postList={this} />;
    }

    return (
      <div className="list-wrapper">
        {list}
        <Dialog
          open={this.state.isDialogOpen}
          onClose={this.handleDialogClose}
          aria-labelledby="delete-post-dialog-title"
          aria-describedby="delete-post-dialog-description"
        >
          <DialogTitle id="delete-post-dialog-title">Delete post?</DialogTitle>
          <DialogContent>
            <DialogContentText id="delete-post-dialog-description">
              Are you sure you want to delete <strong>{this.state.postToDelete.title}</strong>?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handlePostDeletion} color="secondary">Delete</Button>
            <Button onClick={this.handleDialogClose} autoFocus>Cancel</Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default PostsList;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/PostsList/index.js